export const formatUserNameFromEmail = (email: string | null | undefined): string => {
  if (!email) {
    return "";
  }
  const localPart = email.split("@")[0] ?? "";
  const parts = localPart.split(/[._-]/);

  const formattedParts = parts
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase());

  return formattedParts.join(" ") || email;
};
